import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlPagamentosExtraorcamentarias = '/service/contabilidade/ordemCronologicaPortal/'

class DetalhesOrdensPagamentosExtraorcamentariasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicio,
            numeroOrdem: filtro.numeroOrdem,
        }
        return this.conex.post(urlPagamentosExtraorcamentarias + 'detalhesOrdensPagamentosExtraorcamentarias/', JSON.stringify(data))
    }
}

export default DetalhesOrdensPagamentosExtraorcamentariasService
